import axios from "axios";
import { ADDERS_API, MAIN_URL } from "../../API/Api";

const GetAllAdders = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/admin/adders-category`,
        headers: headers,
        params: { ...data },
    });

    return response.data;
};

const GetSingleAdder = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/admin/adders-category/${data}`,
        headers: headers,
    });
    return response.data;
};

const CreateAdder = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MAIN_URL}/admin/adders-category/create`,
        headers: headers,
        data,
    });
    return response.data;
};

const UpdateAdder = async (data, token) => {
    let headers = {
        Accept: "application/json",
        token: `Bearer ${token}`,
    };

    let response = await axios({
        method: "POST",
        baseURL: `${MAIN_URL}/admin/adders-category/${data.id}/edit`,
        headers: headers,
        data,
    });
    return response.data;
};

const UpdateAdderStatus = async (id, token) => {
    let headers = {
        Accept: "application/json",
        token: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MAIN_URL}/admin/adders-category/update-status/${id}`,
        headers: headers,
    });
    return response.data;
};

const DeleteAdder = async (id, token) => {
    let headers = {
        Accept: "application/json",
        token: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${MAIN_URL}/admin/adders-category/${id}/delete`,
        headers: headers,
    });
    return response.data;
};

const GetAllServiceTypes = async (token) => {
    let headers = {
        Accept: "application/json",
        authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${MAIN_URL}/services`,
        headers: headers,
    });
    caches.log(response.data);
    return response.data;
};

const AddersServicev2 = {
    GetAllAdders,
    GetSingleAdder,
    CreateAdder,
    UpdateAdder,
    UpdateAdderStatus,
    DeleteAdder,
    GetAllServiceTypes,
};

export default AddersServicev2;
